import { render, staticRenderFns } from "./InvitacionesStats.vue?vue&type=template&id=f2208068"
import script from "./InvitacionesStats.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesStats.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports